import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";

interface Props<T extends string> {
  value: T | undefined;
  label: string;
  options: { label: string; value: T }[];
  onValueChanged: (value: T) => void;
}
const NumberFormatRadioGroup = <T extends string>({ value, label, options, onValueChanged }: Props<T>) => {
  if (options.length === 0) {
    return null;
  }

  return (
    <FormControl sx={{ gap: 0.5 }}>
      <FormLabel>
        <Typography variant="subtitle2" color="textPrimary">
          {label}
        </Typography>
      </FormLabel>
      <RadioGroup
        value={value ?? options[0]?.value}
        row
        onChange={(_, nextValue) => onValueChanged(nextValue as T)}
        sx={{ pl: 1, gap: 1 }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio sx={{ p: "4px" }} />}
            label={<Typography>{option.label}</Typography>}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default NumberFormatRadioGroup;
